import type { Ticket, TicketPage } from '../types';

export interface TicketStreamState { items: Ticket[]; nextPage: number; total: number | null; complete: boolean }
export const emptyTicketStream = (): TicketStreamState => ({items: [], nextPage: 1, total: null, complete: false});
const key = (ticket: Ticket) => `${ticket.ticketId || ticket._id}:${ticket.mobileTab === 'completed' ? ticket.runId || '' : ''}`;

// Publish each page before requesting the next. Never reorder earlier rows.
export async function streamTickets(fetchPage: (page: number) => Promise<TicketPage>, initial: TicketStreamState,
  publish: (state: TicketStreamState) => void, signal: AbortSignal) {
  let state = initial;
  const seen = new Set(state.items.map(key));
  while (!state.complete && !signal.aborted) {
    const result = await fetchPage(state.nextPage);
    if (signal.aborted) return;
    const total = result.total ?? state.total;
    const additions: Ticket[] = [];
    for (const item of result.items) {
      if (!item.ticketId && !item._id) throw new Error('Un tichet nu are identificator. Reîncarcă lista.');
      const id = key(item);
      if (!seen.has(id)) { seen.add(id); additions.push(item); }
    }
    if (result.items.length && !additions.length) throw new Error('API-ul repetă aceeași pagină. Tichetele deja încărcate sunt păstrate.');
    const items = [...state.items, ...additions];
    // An explicit hasMore=true wins over a stale total (e.g. new assignments).
    const complete = !result.hasMore && (total === null || items.length >= total);
    const incomplete = !complete && (!result.items.length || !result.hasMore);
    state = {items, total, nextPage: state.nextPage + 1, complete};
    publish(state);
    if (incomplete) throw new Error('API-ul a oprit lista înainte de totalul anunțat. Reîncarcă lista pentru rezultate complete.');
  }
}
